import { CAMO_BY_ID, isMasteryTier } from '@vm/content';
import { hex } from './format';
import { Icon } from './icons';

/** Lucide icon per tier (names from the ICONS map in ./icons). */
const TIER_ICON = { bronze: 'medal', silver: 'medal', gold: 'medal', diamond: 'diamond' } as const;

/**
 * Weapon mastery tier badge (Bronze / Silver / Gold / Diamond), tinted with the matching mastery camo colors.
 * Diamond gets a subtle glow. Renders nothing for 'none' (or any unknown tier), so callers can pass the result of
 * `masteryTierFor` / an equipped camo id straight through. Purely cosmetic status — mastery never changes weapon stats.
 */
export function MasteryBadge(props: { tier?: string | null; size?: number; label?: boolean; class?: string; title?: string }) {
  const tier = props.tier;
  if (!isMasteryTier(tier)) return null;
  const camo = CAMO_BY_ID[tier];
  if (!camo) return null;
  const size = props.size ?? 20;
  const text = `${camo.name} mastery`;
  const style: Record<string, string> = {
    '--mb-a': hex(camo.colors[0]),
    '--mb-b': hex(camo.colors[1]),
    '--mb-c': hex(camo.colors[2]),
    '--mb-size': `${size}px`,
  };
  if (camo.glow !== undefined) style['--mb-glow'] = hex(camo.glow);
  return (
    <span
      class={`mastery-badge t-${tier} ${props.label ? 'has-label' : ''} ${props.class ?? ''}`}
      style={style}
      title={props.title ?? text}
      role="img"
      aria-label={text}
    >
      <span class="mastery-badge-gem">
        <Icon name={TIER_ICON[tier]} size={Math.round(size * 0.64)} strokeWidth={2.6} />
      </span>
      {props.label && <b>{camo.name}</b>}
    </span>
  );
}
